import { Box, Stack, useTheme } from "@mui/material";
import TitleComponent from "../../../components/widgets/titleComponent";
import { useTranslation } from "react-i18next";
import FaqDetails from "./faqDetails";

const FaqLayout = () => {
    const theme = useTheme();
    const {t} = useTranslation();

    return (
        <>
            <Box 
                width='100%'
                sx={{
                    backgroundColor: theme.palette.background.default,
                    pb: {xs: 2.5, md: 9}
                }}
            >
                <Stack
                    direction='column'
                    justifyContent='center'
                    alignItems='center'
                    px='5%'
                >
                    <TitleComponent 
                        title={t('contact.faq.title')}
                        description={t('contact.faq.description')}
                        centerMode
                    />

                    {
                        [1,2,3,4,5,6,7,8,9].map((item, index) => {
                            return <FaqDetails 
                                key={index}
                                question={t(`contact.faq.faq${item}.question`)}
                                answer={t(`contact.faq.faq${item}.answer`)}
                                removeMargin={item === 1}
                                expanded={item === 1}
                            />
                        })
                    }
                </Stack>
            </Box>
        </>
    );
}

export default FaqLayout;